var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconRemixProcessing = function SvgIconRemixProcessing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F8F9FD",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M29.586 29H15.524c-.273 0-.469-.24-.469-.514v-2.455a1 1 0 0 1 .333-.744l2.255-2.022c.64-.576 1.683-.576 2.325 0l.402.36a1 1 0 0 0 1.4-.065l2.814-3.03a1.719 1.719 0 0 1 1.252-.53c.489.01.944.187 1.258.517l2.684 2.81a1 1 0 0 1 .277.69v4.47c0 .272-.196.513-.469.513Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M12.444 11.371a2.667 2.667 0 0 0-2.666 2.667v6.933a.889.889 0 0 1-1.778 0v-6.933a4.444 4.444 0 0 1 4.444-4.444h14.204a3.04 3.04 0 0 1 3.04 3.04.889.889 0 0 1-1.777 0c0-.697-.565-1.263-1.263-1.263H12.444Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M30.223 8c.49 0 .889.398.889.889v4.267c0 .589-.478 1.066-1.067 1.066h-4.089a.889.889 0 1 1 0-1.778h3.378V8.89c0-.491.398-.889.889-.889ZM26.666 28.628a2.667 2.667 0 0 0 2.667-2.666v-6.933a.889.889 0 1 1 1.778 0v6.933a4.444 4.444 0 0 1-4.445 4.444H12.462a3.04 3.04 0 0 1-3.04-3.04.889.889 0 0 1 1.778 0c0 .697.565 1.262 1.262 1.262h14.204Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M8.889 32a.889.889 0 0 1-.89-.889v-4.267c0-.589.478-1.066 1.067-1.066h4.09a.889.889 0 1 1 0 1.778H9.777v3.555c0 .491-.398.889-.89.889Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M16.8 20.49c.963 0 1.746-.782 1.746-1.745 0-.962-.783-1.745-1.745-1.745-.963 0-1.746.783-1.746 1.745 0 .963.783 1.745 1.745 1.745Z"
  })));
};
export default SvgIconRemixProcessing;